import {
  InvoiceId,
  type InvoiceLineItemDomainSelectModel,
  InvoiceLineItemId,
} from '@mntn-dev/domain-types'

import { MockModel } from './mock-model.ts'

export const MockInvoiceLineItem = MockModel<InvoiceLineItemDomainSelectModel>(
  ({
    invoiceLineItemId = InvoiceLineItemId(),
    invoiceId = InvoiceId(),
    amount = 10000,
    description = 'Test Description',
  }) => {
    return {
      invoiceLineItemId,
      invoiceId,
      amount,
      description,
    } satisfies InvoiceLineItemDomainSelectModel
  }
)
